var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M10.66 11.894L.88 3 2.9.78l12.22 11.114L2.908 23 .89 20.78z"}})}
var staticRenderFns = []

export { render, staticRenderFns }